module.exports = __webpack_public_path__ + "img/diesel-locomotive-05.b10d57d2.png";